import { registerCatalog } from "@/lib/i18n";

registerCatalog("en", {
  // Navigation
  "nav.home": "My Memos",
  "nav.explore": "Explore",
  "nav.attachments": "Attachments",
  "nav.chatImport": "Chat archive",
  "nav.inbox": "Inbox",
  "nav.settings": "Settings",
  "nav.about": "About",
  "nav.signin": "Sign in",
  "nav.signout": "Sign out",
  "nav.archived": "Archived",
  "nav.shortcuts": "Shortcuts",
  "nav.profile": "Profile",
  "nav.compose": "New memo",

  // Common actions
  "action.save": "Save",
  "action.cancel": "Cancel",
  "action.delete": "Delete",
  "action.edit": "Edit",
  "action.create": "Create",
  "action.confirm": "Confirm",
  "action.retry": "Retry",
  "action.close": "Close",
  "action.copy": "Copy",
  "action.copied": "Copied",
  "action.share": "Share",
  "action.archive": "Archive",
  "action.restore": "Restore",
  "action.pin": "Pin",
  "action.unpin": "Unpin",
  "action.loadMore": "Load more",
  "action.refresh": "Refresh",
  "action.search": "Search",
  "action.back": "Back",
  "action.submit": "Submit",
  "action.upload": "Upload",
  "action.download": "Download",
  "action.reveal": "Reveal",

  // Auth
  "auth.signIn.title": "Sign in to {title}",
  "auth.username": "Username",
  "auth.password": "Password",
  "auth.signIn.submit": "Sign in",
  "auth.signIn.sso": "Continue with {provider}",
  "auth.signIn.noAccount": "Don't have an account?",
  "auth.signIn.createOne": "Create one",
  "auth.signIn.adminFallback": "Admin sign-in",
  "auth.signup.title": "Create your account",
  "auth.signup.firstAdmin.title": "Set up your instance",
  "auth.signup.firstAdmin.description":
    "Create the first administrator account to finish setting up this Memos instance.",
  "auth.signup.submit": "Create account",
  "auth.signup.confirmPassword": "Confirm password",
  "auth.signup.passwordMismatch": "Passwords do not match",
  "auth.error.generic": "Sign-in failed. Check your credentials and try again.",

  // Editor
  "editor.placeholder": "What's on your mind?",
  "editor.mode.post": "Post",
  "editor.mode.article": "Article",
  "editor.visibility.private": "Private",
  "editor.visibility.protected": "Members",
  "editor.visibility.public": "Public",
  "editor.submit": "Save memo",
  "editor.editing": "Editing memo",
  "editor.addLocation": "Add location",
  "editor.addAttachment": "Add attachment",
  "editor.addRelation": "Add relation",
  "editor.setTime": "Set time",
  "editor.discard.confirm": "Discard this draft? This cannot be undone.",
  "editor.contentTooLong": "Content exceeds the {limit} byte limit.",

  // Feed / list
  "feed.empty.title": "No memos yet",
  "feed.empty.body": "Write your first memo above to get started.",
  "feed.noResults": "No memos match the current filters.",
  "feed.loadError": "Couldn't load memos.",
  "feed.offline": "You're offline. Reconnect to load new memos.",
  "feed.forbidden": "You don't have permission to view these memos.",
  "feed.filter.clear": "Clear filters",
  "feed.filter.clearAll": "Clear all",

  "agent.filter.all": "All",
  "agent.filter.ready": "Ready",
  "agent.filter.empty": "No ready memos",
  "agent.action.run": "Run",
  "agent.action.rerun": "Re-run",
  "agent.action.approve": "Approve",
  "agent.panel.title": "Agent",
  "agent.panel.description": "Background processing state and extracted artifacts.",
  "agent.panel.empty": "No agent artifact is available yet.",
  "agent.forbidden": "You don't have permission to access this agent state.",
  "agent.unavailable": "Agent state is currently unavailable.",
  "agent.toast.runQueued": "Agent run queued",
  "agent.toast.rerunQueued": "Agent re-run queued",
  "agent.toast.approved": "Agent approval submitted",
  "agent.field.skill": "Skill",
  "agent.field.pipeline": "Pipeline",
  "agent.field.plan": "Plan",
  "agent.field.mode": "Mode",
  "agent.field.action": "Action",
  "agent.field.reason": "Reason",
  "agent.field.confidence": "Confidence",
  "agent.field.routeStatus": "Route status",
  "agent.artifact.summary": "Summary",
  "agent.artifact.keyPoints": "Key points",
  "agent.artifact.suggestedTags": "Suggested tags",
  "agent.artifact.actionItems": "Action items",
  "agent.status.unprocessed": "Unprocessed",
  "agent.status.queued": "Queued",
  "agent.status.processing": "Processing",
  "agent.status.ready": "Ready",
  "agent.status.skipped": "Skipped",
  "agent.status.needs_review": "Needs review",
  "agent.status.failed": "Failed",
  "agent.status.stale": "Stale",

  // Memo
  "memo.delete.confirm": "Delete this memo? This cannot be undone.",
  "memo.comments": "Comments",
  "memo.comments.empty": "No comments yet.",
  "memo.comment.placeholder": "Write a comment…",
  "memo.copyLink": "Copy link",
  "memo.copyContent": "Copy content",
  "memo.shareImage": "Share as image",

  // Article
  "article.label": "Article",
  "article.title": "Title",
  "article.titlePlaceholder": "Give this article a clear title",
  "article.bodyPlaceholder": "Write the article in Markdown...",
  "article.untitled": "Untitled article",
  "article.read": "Read article",
  "article.readingTime": "{minutes} min read",

  // Chat import
  "chatImport.title": "Codex chat archive",
  "chatImport.addFile": "Add JSONL",
  "chatImport.chooseFile": "Choose JSONL",
  "chatImport.empty": "Drop a Codex JSONL file",
  "chatImport.emptyHint": "The file is parsed locally before publishing.",
  "chatImport.sessionCount": "{count} sessions",
  "chatImport.imported": "Imported {count} sessions",
  "chatImport.stats": "{turns} turns · {tools} tools",
  "chatImport.skipped": "Skipped {count} invalid lines",
  "chatImport.mode": "Article detail",
  "chatImport.mode.review": "Review",
  "chatImport.mode.conversation": "Conversation",
  "chatImport.mode.full": "With tools",
  "chatImport.visibility": "Visibility",
  "chatImport.attachSource": "Attach source JSONL",
  "chatImport.sourceWarning":
    "Article text is redacted. The original JSONL attachment is unchanged and follows the article visibility.",
  "chatImport.sourceTooLarge":
    "The {size} source exceeds the {limit} attachment limit, so it won't be uploaded. You can still publish the article.",
  "chatImport.preview": "Preview",
  "chatImport.markdown": "Edit Markdown",
  "chatImport.publish": "Publish article",
  "chatImport.published": "Article published",
  "chatImport.error.fileType": "Choose one or more .jsonl files.",
  "chatImport.error.parse": "Couldn't parse this JSONL file.",
  "chatImport.error.publish": "Couldn't publish the article.",
  "chatImport.error.title": "The first non-empty line must be an H1 title.",
  "chatImport.error.tooLong": "Choose a shorter article mode or edit the Markdown.",

  // Settings
  "settings.myAccount": "My Account",
  "settings.accessToken": "Access Tokens",
  "settings.preference": "Preferences",
  "settings.webhook": "Webhooks",
  "settings.tags": "Tags",
  "settings.member": "Members",
  "settings.system": "System",
  "settings.memo": "Memo",
  "settings.storage": "Storage",
  "settings.notification": "Notification",
  "settings.sso": "SSO",
  "settings.resourceStats": "Resource Stats",
  "settings.theme": "Theme",
  "settings.theme.system": "System",
  "settings.theme.light": "Light",
  "settings.theme.dark": "Dark",
  "settings.theme.paper": "Paper",
  "settings.language": "Language",
  "settings.defaultVisibility": "Default memo visibility",

  // Status / errors
  "error.403.title": "No access",
  "error.403.body": "You don't have permission to view this page.",
  "error.404.title": "Not found",
  "error.404.body":
    "The page or resource you're looking for doesn't exist or the link has expired.",
  "error.generic": "Something went wrong.",
  "error.network": "Network error. Check your connection and retry.",
  "error.chunk": "A new version is available. Refresh to update.",
  "state.loading": "Loading…",
  "state.empty": "Nothing here yet.",

  // About
  "about.version": "Version",
  "about.commit": "Commit",
  "about.license": "License",
  "about.demo": "Demo instance",
  "about.links": "Links",
});
